module.exports = __webpack_public_path__ + "img/check.a6b0b531.svg";